<template>
  <div class="referred">
    <v-btn v-if="$route.params.rec_id==0" color="primary"
           style="border-radius: 0px;position: fixed;margin-top: 2px;width: 100%" class="enter-btn"
           v-on:click="dialog_model=true,model_txt=''">{{ $t('addNewProduct') }}
    </v-btn>
    <v-card-text>
      <div style="margin-top: 50px">
        <div class="req-list">
          <div class="req-card" v-for="(item,index) in list" :key="item.Id">
            <div>

              <div class="flex-no-wrap justify-space-between">
                <div @click="delete_dialog(index)">
                  <div
                    class="req-name"
                    v-text="item.ProductName"
                  ></div>

                  <span class="req-code">
                    <span class="bold">
                    {{ item.Qty }} {{ $t('numbers') }}
                    </span>
                  </span>
                </div>
                <v-row>
                  <v-col cols="8">
                    <div class="status">{{ item.StatusName }}</div>
                  </v-col>
                  <v-col cols="4" @click="attach_dialog(item)">
                    <div class="status">
                      <v-icon>mdi-attachment</v-icon>
                    </div>
                  </v-col>
                </v-row>
              </div>

            </div>

          </div>

        </div>
      </div>

    </v-card-text>
    <div style="width: 100%" class="text-center">
      <label class="text-center" v-if="list.length && $route.params.rec_id==0"
             style="color: white">{{ $t('click_for_add_product_order') }}</label>
    </div>
    <v-btn v-if="list.length && $route.params.rec_id==0" color="primary"
           style="font-weight:bold;border-radius: 0px; height: 55px"
           class="enter-btn footer_btn" v-on:click="pre_upload_files()">{{ $t('add_product_order') }}
    </v-btn>
    <v-row justify="center">
      <v-dialog
        v-model="dialog_model"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('addProduct') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-row>
                <v-col class="p-1">

                  <treeselect
                    :multiple="false"
                    :load-options="load_models"
                    :normalizer="normalizer_models"
                    :async="true"
                    :always-open="always_open"
                    :append-to-body="false"
                    :placeholder="$t('searchProduct')"
                    v-model="auto_complete_model"
                  />
                  {{ model_txt }}
                </v-col>
              </v-row>

              <v-row>

                <v-col cols="4">
                  <v-text-field
                    :placeholder="$t('count')"
                    v-model="product_count"/>
                </v-col>

              </v-row>
              <v-row>

                <v-col cols="12">
                  <v-text-field
                    :placeholder="$t('description')"
                    v-model="product_summary"/>
                </v-col>

              </v-row>


            </v-row>
            <v-row>

              <v-col cols="6">
                <v-text-field
                  label="قیمت خرید"
                  v-model="product_buy_price"/>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="قیمت فروش"
                  v-model="product_sell_price"/>
              </v-col>

            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="dialog_model = false"
            >{{ $t('cancel') }}
            </v-btn>
            <v-btn
              v-if="auto_complete_model!=null"
              class="accept-btn"
              text
              @click="goToDetail()"
            >{{ $t('ok') }}
            </v-btn>
            <v-btn
              v-if="auto_complete_model==null"
              class="accept-btn"
              text
              @click="goToNewProduct()"
            >افزودن کالای جدید
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="delete_dialog_modal"
        persistent
        max-width="290"
      >

        <v-card>
          <v-card-title class="headline">{{ $t('deleteProduct') }}</v-card-title>
          <v-card-text>{{ $t('sureToDeleteProduct') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="delete_dialog_modal = false"
            >{{ $t('no') }}
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="delete_dialog_modal = false,list.splice(status_form,1)"
            >{{ $t('yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="show_attach_dialog"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('attachments') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-row>
                <v-col class="p-1">
                  <div class="req-attachment">
                    <div class="card">
                      <v-row class="">
                        <v-col cols="6">{{ $t('add_file') }}</v-col>
                        <v-col class="text-end" style="padding: 0px" cols="6">
                          <v-btn
                            color="primary"
                            dark
                            @click="select_file()"
                            class="ma-2"
                          >
                            <v-icon
                              dark
                            >
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </div>

                  <v-row>
                    <input id="fileUpload" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.gif" type="file" hidden
                           v-on:change="input_file_changed">
                    <v-row style="margin-bottom: 35px; margin-top: 35px;">
                      <v-col cols="4"
                             v-for="(item, i) in selected_item_attach.files"
                             :key="i"
                      >
                        <v-icon v-on:click="delete_file(i)" style="color: crimson">
                          mdi-close
                        </v-icon>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                        <v-img :src="item.file" width="100px" height="100px"/>

                      </v-col>
                    </v-row>
                  </v-row>

                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="show_attach_dialog = false"
            >{{ $t('ok') }}
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>
  </div>

</template>
<script>
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import axios from 'axios'
import Vue from 'vue'

import {bus} from '../../main'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      auto_complete_model: null,
      search_entries: [],
      model_txt: '',
      is_pre: '',
      always_open: true,
      delete_dialog_modal: false,
      status_form: 0,
      dialog_model: false,
      product_count: '',
      product_summary: '',
      product_sell_price: '',
      product_buy_price: '',

      product_items: [],
      upload_images: [],
      branch_id: 0,
      list: [],
      errors: [],
      selected_post: 0,
      selected_branch: 0,
      // request_items: [],
      // last_request_items: [],
      show_loading: false,
      no_info: true,
      page: 0,
      selected_item_attach: {},
      show_attach_dialog: false,

      normalizer_models(node) {
        return {
          id: node.ProductId,
          label: node.ProductName,
        }
      },
      first: true,
    }
  },
  computed: {},
  components: {Treeselect},
  watch: {
    auto_complete_model() {
      if (this.auto_complete_model == null) {
        this.always_open = true;
      } else {
        this.always_open = false;

      }

      for (var i = 0; i < this.search_entries.length; i++) {
        if (this.search_entries[i].ProductId == this.auto_complete_model) {
          this.model_txt = this.search_entries[i].ProductName
          this.is_pre = this.search_entries[i].IsPreProduct
        }
      }
    },
  },
  mounted() {
    if (this.$route.params.rec_id != 0) {
      this.get_factors()
    }
    this.get_branch_permission()

    this.selected_post = parseInt(localStorage.getItem('selected_post'))
  },

  methods: {
    select_file() {
      document.getElementById('fileUpload').click()
    },
    delete_file(index) {
      this.selected_item_attach.files.splice(index, 1)
    },
    input_file_changed() {
      var self = this

      var reader = new FileReader()
      var f = document.getElementById('fileUpload').files

      reader.onloadend = function () {
        // console.log(reader.result);
        if (!reader.result.startsWith('data:image/webp')) {
          self.resizeBase64Img(reader.result, 700, 700).then(function (newImg) {
            // $("body").append(newImg[0]);
            // console.log("resized",newImg[0].src)
            var obj = {file: newImg[0].src, preview: reader.result, upload: 0}
            self.selected_item_attach.files.push(obj)
          })
          // console.log(obj)
        } else {
          bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
        }
      }
      reader.readAsDataURL(f[0])
    },
    resizeBase64Img(base64, minimum) {
      var canvas = document.createElement('canvas')

      var deferred = $.Deferred()
      $('<img/>').attr('src', base64).load(function () {
        var last_width = this.width
        var last_height = this.height

        if (last_width > last_height) {
          last_width = (last_width * minimum) / last_height
          last_height = minimum
        } else {
          last_height = (last_height * minimum) / last_width
          last_width = minimum
        }
        canvas.width = last_width
        canvas.height = last_height
        var context = canvas.getContext('2d')

        console.log(this.width, this.height)
        context.scale(last_width / this.width, last_height / this.height)
        context.drawImage(this, 0, 0)

        deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
      })
      return deferred.promise()
    },

    attach_dialog(item) {
      this.show_attach_dialog = true;
      this.selected_item_attach = item;
    },
    delete_dialog(index) {
      if (this.$route.params.rec_id == 0) {
        this.delete_dialog_modal = true
        this.status_form = index
      }
    },
    load_models({action, searchQuery, callback}) {
      this.model_txt = searchQuery
      this.auto_complete_model = null
      var self = this
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options

          var passing_data = JSON.parse(localStorage.getItem('request_data'))

          const send_data = {
            MainProductId: 0,
            TxtSearch: searchQuery,
          }
          this.axios.post('/GetProductLowInfosByKeword_GoodsReq', send_data, {})
            .then(response => {
              self.search_entries = response.data.products
              options = response.data.products
              callback(null, options)
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })

          //
          // axios.post('/api/admin/product_search-tags', {
          //   search: searchQuery,
          //
          // }).then(function (response) {
          //   options = response.data;
          //   callback(null, options);
          //   // localStorage.setItem("api_token", response.data.access_token);
          //   // self.$router.push({ path: 'notes' });
          // })
          //   .catch(function (error) {
          //     self.message = 'Incorrect E-mail or password';
          //     self.showMessage = true;
          //     console.log(error);
          //   });

          //  const options = this.get_keywords(searchQuery);
          // const options = [1, 2, 3, 4, 5].map(i => ({
          //     id: `${searchQuery}-${i}`,
          //     name: `${searchQuery}-${i}`,
          // }))
        })
      }
    },

    goToDetail() {
      // bus.$emit('show_toast', [2000, this.product_count])

      this.product_count = this.persian_to_english(this.product_count);

      if (this.auto_complete_model != null && this.product_count != 0 && this.product_count != '' &&
        this.product_buy_price != '' && this.product_sell_price != '') {

        this.list.push({
          ProductId: this.auto_complete_model,
          Qty: this.product_count,
          IsPreProduct: this.is_pre,
          ProductName: this.model_txt,
          ProductDesc: this.product_summary,
          SaleAmount: this.toEnglishDigits(this.product_sell_price),
          PurchaseAmount: this.toEnglishDigits(this.product_buy_price),
          files: [],
          Images: []
        })
        this.dialog_model = false
        this.auto_complete_model = null
        this.product_count = ''
        this.product_summary = ''
      }
    },
    goToNewProduct(){
      this.$router.push({path:'/product-request/add-pre-product'})
    },
    get_factors() {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        MasterId: this.$route.params.rec_id,
      }

      console.log('pre request called')
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetGoodsProductsByMasterId', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.list = response.data.items
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_branch_permission() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var party_id = localStorage.getItem('party_id')

      const send_data = {
        UserId: user_id,
        Role: 'BranchDefinition',
        PartyId: party_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ZkGetUserPermission', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.branch_id = response.data.UserBranchId
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    pre_upload_files() {
      this.upload_images = [];
      var first_index_file = -1;
      for (var x = 0; x < this.list.length; x++) {
        if (this.list[x].files.length > 0) {
          if (first_index_file == -1) {
            first_index_file = x;
          }
        }
      }

      if (first_index_file != -1) {
        this.upload_image(first_index_file, 0);
      } else {
        this.add_factor();
      }

    },
    upload_image(item_index, index) {
      console.log("upload file ", item_index, index);
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var form_data = new FormData()
      form_data.append('UserId', user_id)
      form_data.append('Format', 'png')
      form_data.append('ReqType', 9)
      form_data.append('DocType', 1)
      var my_file = this.list[item_index].files[index].file

      var file = this.dataURLtoFile(my_file, 'attach.png')
      form_data.append('Picture', file)

      this.axios.post('UploadFile', form_data, {})
        .then(response => {
          // self.send_signature(response.data.ArchiveId,response.data.ImageName);
          if (response.data.error == 0) {
            self.list[item_index].files[index].upload = 1
            self.list[item_index].files[index].ArchiveId = response.data.ArchiveId;
            self.list[item_index].files[index].ImageName = response.data.ImageName;
            self.list[item_index].Images.push(response.data.ImageName);
            self.upload_images.push({ImageName: response.data.ImageName, ProductId: self.list[item_index].ProductId});

            if (index < self.list[item_index].files.length - 1) {
              self.upload_image(item_index, index + 1)
            } else {
              if (this.list.length - 1 > item_index) {
                var first_index_file = -1;
                for (var x = item_index + 1; x < this.list.length; x++) {
                  if (this.list[x].files.length > 0) {
                    if (first_index_file == -1) {
                      first_index_file = x;
                    }
                  }
                }
                if (first_index_file != -1) {
                  self.upload_image(first_index_file, 0)

                } else {
                  this.add_factor()

                }
              } else {
                this.add_factor()

              }
            }

          } else {
            self.files[index].upload = 2
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },

    add_factor() {
      // this.request_items = [];
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var product_request = JSON.parse(localStorage.getItem('request_product'))
      var request_id = 0;
      var Payfor = 0;
      if (product_request.request) {
        request_id = product_request.request;
      }
      if (product_request.user) {
        Payfor = product_request.user
      }
      for (var z = 0; z < self.list.length; z++) {
        self.list[z].Images = JSON.stringify(self.upload_images);
      }

      const send_data = {
        SourceBranchId: this.branch_id,
        Summary: product_request.summary,
        DestBranchId: product_request.branch,
        UserId: user_id,
        Payfor: Payfor,
        CategoryId: product_request.category,
        CostCenterId: request_id,
        Products: this.list,
      }

      console.log('pre request called')
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddGoodsReq', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            bus.$emit('show_toast', [1500, response.data.msg])
            self.$router.go(-1)
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new File([u8arr], filename, {type: mime})
    },

  }
}
</script>
<style>
.v-application .headline {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: "IRANSans" !important;
}
</style>
